// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__3KlPa","skeleton_user":"Skeleton_skeleton_user__2Gp1K","content":"Skeleton_content__pmufu","img":"Skeleton_img__10PN6"};